// src/components/math/MathSymbolPicker.tsx

import { Editor } from '@tiptap/react';
import katex from 'katex';
import 'katex/dist/katex.min.css';

interface MathSymbolPickerProps {
  editor: Editor;
}

const symbols: { latex: string; label?: string }[] = [
  { latex: '\\alpha' },
  { latex: '\\beta' },
  { latex: '\\gamma' },
  { latex: '\\delta' },
  { latex: '\\epsilon' },
  { latex: '\\pi' },
  { latex: '\\theta' },
  { latex: '\\lambda' },
  { latex: '\\mu' },
  { latex: '\\int' },
  { latex: '\\sum' },
  { latex: '\\infty' },
  { latex: '\\sqrt{x}' },
  { latex: 'x^2' },
  { latex: 'x_i' },
  { latex: '\\frac{a}{b}' },
  { latex: '\\approx' },
  { latex: '\\neq' },
  { latex: '\\leq' },
  { latex: '\\geq' },
  { latex: '\\rightarrow' },
  { latex: '\\leftarrow' },
  { latex: '\\pm' },
  { latex: '\\cdot' },
];

export const MathSymbolPicker = ({ editor }: MathSymbolPickerProps) => {
  const insertSymbol = (latex: string) => {
    editor.chain().focus().insertMathInline(latex).run();
  };

  return (
    <div className="grid grid-cols-6 gap-2 max-h-[300px] overflow-y-auto">
      {symbols.map((sym, i) => (
        <button
          key={i}
          className="p-1 border rounded hover:bg-muted transition text-center"
          onClick={() => insertSymbol(sym.latex)}
          title={sym.label || sym.latex}
          dangerouslySetInnerHTML={{
            __html: katex.renderToString(sym.latex, { throwOnError: false }),
          }}
        />
      ))}
    </div>
  );
};
